<template>
  <div class="monitor" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="yuliang" ref="yuliang" style="margin-top:0;">
        <div class="select" ref="districtrainOperation">
          <span class="desc">起止时间:</span>
          <div style="display: inline-block;">
            <el-date-picker
              v-model="query.begTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择开始时间"
              default-time="08:00:00"
              :clearable="false"
              :editable="false"
              :picker-options="Global.pickerOptionsStart(query.endTime)"
            ></el-date-picker>
            <span class="desc">至</span>
            <el-date-picker
              v-model="query.endTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择结束时间"
              default-time="08:00:00"
              :clearable="false"
              :editable="false"
              :picker-options="Global.pickerOptionsEnd(query.begTime)"
            ></el-date-picker>
          </div>
          <span id="select" @click="tabledata">查询</span>
          <span id="export" @click="exportExcel">
            <span class="export-icon"></span>导出
          </span>
        </div>
        <div class="tableDiv" ref="tableDiv" v-loading="loading">
          <table>
            <thead ref="thead">
              <tr>
                <th>站名</th>
                <th v-html="yuLiangTh"></th>
                <th>站名</th>
                <th v-html="yuLiangTh"></th>
                <th>站名</th>
                <th v-html="yuLiangTh"></th>
                <th>站名</th>
                <th v-html="yuLiangTh"></th>
                <th class="gutter" style="width: 4px;"></th>
              </tr>
            </thead>
            <tbody ref="tbody" v-html="showTrData"></tbody>
          </table>
          <div>
            <table>
              <tbody>
                <tr><td colspan="8">最大: {{maxStationName}} {{maxStationRain}}毫米</td></tr>
                <tr><td colspan="8">全县平均: {{avgStationRain}}毫米</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import monitorTypes from '@/store/types/monitor'
import timer from '@/utils/timer'
export default {
  data () {
    return {
      loading: true,
      timerFun: '',
      showTrData: '',
      query: {
        addvcd: '330324',
        begTime: '',
        endTime: '',
        sid: '22'
      },
      yuLiangTh: '雨量</br>(mm)',
      maxStationName: '',
      maxStationRain: '',
      avgStationRain: ''
    }
  },
  methods: {
    tabledata () {
      this.loading = true
      this.query.mainStation = true
      this.$store
        .dispatch(monitorTypes.GET_ALLRAINFALL, this.query)
        .then(data => {
          this.getShowDataTr(data)
          this.loading = false
        })
    },
    getShowDataTr (data) {
      this.showTrData = ''
      if (data !== {} && data !== undefined) {
        data.stationList.forEach((element, index) => {
          if (index === 0) {
            this.showTrData = '<tr>'
          }
          if (index % 4 === 0 && index !== 0) {
            this.showTrData += '</tr><tr>'
          }
          this.showTrData += '<td>' + element.stationName + '</td>' + '<td>' + element.stationRain + '</td>'
        })
        let stationRainLength = 4 - (data.stationList.length % 4)
        if (stationRainLength !== 4) {
          for (let index = 0; index < stationRainLength; index++) {
            this.showTrData += '<td></td><td></td>'
          }
        }
        if (this.showTrData !== '') {
          this.showTrData += '</tr>'
        }
        this.maxStationName = data.maxStationName
        this.maxStationRain = data.maxStationRain
        this.avgStationRain = data.avgStationRain.toFixed(2)
      }
    },
    exportExcel () {
      this.query.mainStation = true
      this.$store.dispatch(monitorTypes.EXPORT_ALLRAINFALL, this.query).then(data => {
        window.location.href = this.Global.basePath + data.data
        this.loading = false
      })
    },
    judgeCurrentTime () { // 默认选择时间
      let nowdate = new Date()
      let hh = nowdate.getHours()
      if (hh >= 8) {
        this.query.begTime = this.$moment(nowdate).format('YYYY-MM-DD 08:00')
        this.query.endTime = this.$moment(nowdate).format('YYYY-MM-DD HH:00')
      } else {
        // 昨天
        let nowdate = new Date()
        let date = new Date()
        date.setTime(date.getTime() - 1000 * 60 * 60 * 24)
        this.query.begTime = this.$moment(date).format('YYYY-MM-DD 08:00')
        this.query.endTime = this.$moment(nowdate).format('YYYY-MM-DD HH:00')
      }
    },
    getTime () {
      let now = new Date()
      var preDate = new Date(now.getTime() - 24 * 60 * 60 * 1000) // 前一天
      // this.query.begTime = this.Global.timeFormat(preDate)
      this.query.begTime = this.Global.timeFormat(new Date(preDate.getFullYear(), preDate.getMonth(), preDate.getDate(), preDate.getHours(), '00'))
      // this.query.endTime = this.Global.timeFormat(now)
      this.query.endTime = this.Global.timeFormat(new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), '00'))
    }
  },
  created () {
    // this.getTime()
    this.judgeCurrentTime()
    this.tabledata()
  },
  mounted () {
    this.timerFun = setInterval(() => {
      // this.getTime()
      this.judgeCurrentTime()
      this.tabledata()
    }, timer.TIMER_MIN)
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      this.$refs['yuliang'].style.height =
        contentDiv[0].offsetHeight - 30 + 'px'
      this.$refs['tableDiv'].style.height =
        this.$refs['yuliang'].offsetHeight - 110 - this.$refs['districtrainOperation'].offsetHeight + 'px'
      this.$refs['thead'].style.width = this.$refs['tbody'].offsetWidth + 'px'
      this.$refs['tbody'].style.height =
        this.$refs['tableDiv'].offsetHeight - this.$refs['thead'].offsetHeight + 'px'
    })
  },
  beforeDestroy () {
    clearInterval(this.timerFun)
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style lang="less" scoped>
.monitor {
  .tableDiv {
    color: #000;
    margin-top: 5px;
    width: 98%;
    margin-left: 1%;
    table {
      width: 100%;
      font-size: 15px;
      thead {
        display: table;
        width: 100%;
        height: 50px;
        table-layout: fixed;
      }
      tr {
        height: 50px;
        display: table;
        width: 100%;
        table-layout: fixed;
        background: rgb(245, 248, 251);
        th {
          text-align: center;
          vertical-align: middle;
          border: 1px solid rgb(235, 239, 246);
        }
        th:nth-child(even) {
          width: 5%;
        }
        th:nth-child(odd) {
          width: 20%;
        }
      }
      tbody {
        overflow-y: scroll;
        display: block;
        height: 100px;
        /deep/ tr {
          display: table;
          width: 100%;
          table-layout: fixed;
          text-align: center;
          vertical-align: middle;
          height: 50px;
          td {
            border: 1px solid rgb(235, 239, 246);
          }
          td:nth-child(even) {
            width: 5%;
          }
          td:nth-child(odd) {
            width: 20%;
          }
        }
        /deep/ tr:nth-child(even) {
          background: rgb(232, 242, 251);
        }
        /deep/ tr:nth-child(odd) {
          background: rgb(255, 255, 255);
        }
      }
    }
  }
}
</style>
